<template>
  <div>
    <AdminMenu v-if="isAdmin" data-test="icon-admin" />
    <UserIconAndSubMenu v-else />
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import AdminMenu from './AdminMenu.vue'
import UserIconAndSubMenu from './UserIconAndSubMenu/UserIconAndSubMenu.vue'

const { user } = useUserStore()
const isAdmin =
  user.value.isStaff ||
  user.value.isShadowingClient ||
  user.value.isShadowingMerchant
</script>
